/**
 * User roles — the client's mirror of the server's catalog, plus the
 * human-readable label + color for each.
 *
 * ⚠️ ROLES is HAND-MIRRORED with `abaintake-keystonejs/utils/auth.util.ts`
 * (there is no shared package between the repos — see the workspace
 * CLAUDE.md). Each repo pins the SAME expected list in its own test suite
 * (tests/unit/roles.test.js here, tests/auth/roles.test.ts there), so a
 * drift on either side breaks that side's build before it can ship.
 *
 * The ROLES catalog was moved here from stores/authStore.js (2026-09-11,
 * auth refactor) so tests and light modules can import it without dragging
 * the whole store graph behind it; the store re-exports it for every
 * existing import site. This file used to import ROLES FROM the store — the
 * direction is now reversed to break that cycle.
 */
export const ROLES = {
  SYSTEM_ADMIN: "SystemAdmin",
  LEAD_AGENCY_OWNER: "LeadAgencyOwner",
  LEAD_AGENCY_MANAGER: "LeadAgencyManager",
  LEAD_AGENCY_SUPPORT: "LeadAgencySupport",
  COMPANY_OWNER: "CompanyOwner",
  COMPANY_MANAGER: "CompanyManager",
  COMPANY_SUPPORT: "CompanySupport",
}

/**
 * Human-readable label + Vuetify color for every role. Used by the admin
 * users list and the header profile menu so the chip styling stays
 * consistent across the app.
 */
export const ROLE_LABELS = {
  [ROLES.SYSTEM_ADMIN]: { label: "System Administrator", color: "error" },
  [ROLES.LEAD_AGENCY_OWNER]: { label: "Lead Agency Owner", color: "warning" },
  [ROLES.LEAD_AGENCY_MANAGER]: { label: "Lead Agency Manager", color: "primary" },
  [ROLES.LEAD_AGENCY_SUPPORT]: { label: "Lead Agency Support", color: "info" },
  [ROLES.COMPANY_OWNER]: { label: "Company Owner", color: "success" },
  [ROLES.COMPANY_MANAGER]: { label: "Company Manager", color: "secondary" },
  [ROLES.COMPANY_SUPPORT]: { label: "Company Support", color: "default" },
}

/** Convenience accessors so callers don't have to grok the shape. */
export function roleLabel(role) {
  return ROLE_LABELS[role]?.label ?? role ?? "—"
}

export function roleColor(role) {
  return ROLE_LABELS[role]?.color ?? "default"
}
